
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[url]",
      function () {
        return require("private-next-pages/docs/[url].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/[url]"])
      });
    }
  